import { useEffect, useRef } from 'react';

const useAutoUpdate = (panelKey) => {
    const initialVersion = useRef(null);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                // Fetch versions.json with cache-busting timestamp
                const res = await fetch(`/versions.json?t=${new Date().getTime()}`);
                if (!res.ok) return;

                const versions = await res.json();
                const currentVersion = versions[panelKey];

                if (currentVersion) {
                    if (initialVersion.current === null) {
                        // First load: store the initial version
                        initialVersion.current = currentVersion;
                    } else if (initialVersion.current !== currentVersion) {
                        // Version changed! Hard refresh the page
                        console.log(`[AutoUpdate] New version detected for ${panelKey}: ${currentVersion}. Refreshing...`);
                        window.location.reload(true);
                    }
                }
            } catch (err) {
                // Ignore fetch errors (e.g. offline, file missing)
                console.error("[AutoUpdate] Error checking version:", err);
            }
        };

        // Check immediately
        checkVersion();

        // Check every 10 seconds
        const intervalId = setInterval(checkVersion, 10000);

        return () => {
            clearInterval(intervalId);
        };
    }, [panelKey]);
};

export default useAutoUpdate;
